import { useState, useEffect } from "react"
import api from '../../../utils/api'

/* form */
import Input from "../../../shared/components/form/input"
import Radio from "../../../shared/components/form/Radio"
import Select from 'react-select'
import selectStyles from "../../../shared/css/SelectStyle"
import FormLayout from "../../../shared/components/FormLayout/FormLayout"
import FormSection from "../../../shared/components/FormLayout/FormSection"
import Button from "../../../shared/components/Button/Button"
import { FaTrashAlt, FaPlus, FaFileInvoiceDollar, FaPencilAlt, FaLink, FaArrowUp } from 'react-icons/fa'

import NcmSearchTrigger from '../NcmSearchTrigger'
import CfopSearchTrigger from '../CfopSearchTrigger'
import ClientSearchTrigger from '../ClientSearchTrigger'
import UfSelect from "../../../shared/components/UfSelect/UfSelect"
import CitySelect from "../../../shared/components/CitySelect/CitySelect"
import CepSearchTrigger from "../../../shared/components/CepSearchTrigger/CepSearchTrigger"
import Modal from "../../../shared/modal/Modal"
import ConfirmDeleteModal from "../../../shared/components/ConfirmDeleteModal/ConfirmDeleteModal"
import useFlashMessage from '../../../hooks/useFlashMessage'

import './FormInvoice.css'

const TYPE_OPTIONS = [
    { selectName: "type", value: "nfe", label: "NF-e — Nota Fiscal de Venda" },
    { selectName: "type", value: "cte", label: "CT-e — Conhecimento de Transporte" },
]

const IE_INDICATOR_OPTIONS = [
    { selectName: "ieIndicator", value: "contribuinte", label: "Contribuinte de ICMS" },
    { selectName: "ieIndicator", value: "isento", label: "Contribuinte isento de IE" },
    { selectName: "ieIndicator", value: "nao_contribuinte", label: "Não contribuinte" },
]

const UNIT_OPTIONS = [
    { selectName: "unit", value: "UN", label: "UN — Unidade" },
    { selectName: "unit", value: "PC", label: "PC — Peça" },
    { selectName: "unit", value: "PAR", label: "PAR — Par" },
    { selectName: "unit", value: "DZ", label: "DZ — Dúzia" },
    { selectName: "unit", value: "CX", label: "CX — Caixa" },
    { selectName: "unit", value: "KIT", label: "KIT — Kit" },
    { selectName: "unit", value: "M", label: "M — Metro" },
    { selectName: "unit", value: "M2", label: "M² — Metro quadrado" },
    { selectName: "unit", value: "CM", label: "CM — Centímetro" },
    { selectName: "unit", value: "KG", label: "KG — Quilograma" },
    { selectName: "unit", value: "G", label: "G — Grama" },
    { selectName: "unit", value: "L", label: "L — Litro" },
    { selectName: "unit", value: "ML", label: "ML — Mililitro" },
    { selectName: "unit", value: "RL", label: "RL — Rolo" },
    { selectName: "unit", value: "FD", label: "FD — Fardo" },
    { selectName: "unit", value: "SC", label: "SC — Saco" },
    { selectName: "unit", value: "CT", label: "CT — Cento" },
    { selectName: "unit", value: "MIL", label: "MIL — Milheiro" },
]

// Tabela de Origem da Mercadoria (Convênio ICMS 38/2013) — código fechado, não texto livre.
const ORIGIN_OPTIONS = [
    { selectName: "origin", value: "0", label: "0 — Nacional" },
    { selectName: "origin", value: "1", label: "1 — Estrangeira, importação direta" },
    { selectName: "origin", value: "2", label: "2 — Estrangeira, adquirida no mercado interno" },
    { selectName: "origin", value: "3", label: "3 — Nacional, conteúdo de importação > 40%" },
    { selectName: "origin", value: "4", label: "4 — Nacional, processo produtivo básico" },
    { selectName: "origin", value: "5", label: "5 — Nacional, conteúdo de importação ≤ 40%" },
    { selectName: "origin", value: "6", label: "6 — Estrangeira, importação direta, sem similar nacional" },
    { selectName: "origin", value: "7", label: "7 — Estrangeira, mercado interno, sem similar nacional" },
    { selectName: "origin", value: "8", label: "8 — Nacional, conteúdo de importação > 70%" },
]

// Tabela B do CST do ICMS (Ajuste SINIEF 07/2001) — usada no regime normal (Lucro Presumido/Real).
const CST_OPTIONS = [
    { selectName: "cst", value: "00", label: "00 — Tributada integralmente" },
    { selectName: "cst", value: "10", label: "10 — Tributada e com cobrança do ICMS por ST" },
    { selectName: "cst", value: "20", label: "20 — Com redução de base de cálculo" },
    { selectName: "cst", value: "30", label: "30 — Isenta/não tributada e com cobrança do ICMS por ST" },
    { selectName: "cst", value: "40", label: "40 — Isenta" },
    { selectName: "cst", value: "41", label: "41 — Não tributada" },
    { selectName: "cst", value: "50", label: "50 — Suspensão" },
    { selectName: "cst", value: "51", label: "51 — Diferimento" },
    { selectName: "cst", value: "60", label: "60 — ICMS cobrado anteriormente por ST" },
    { selectName: "cst", value: "70", label: "70 — Redução de base de cálculo e cobrança do ICMS por ST" },
    { selectName: "cst", value: "90", label: "90 — Outras" },
]

// CSOSN (Ajuste SINIEF 03/2010) — usada no Simples Nacional, substitui o CST.
const CSOSN_OPTIONS = [
    { selectName: "csosn", value: "101", label: "101 — Tributada pelo Simples com permissão de crédito" },
    { selectName: "csosn", value: "102", label: "102 — Tributada pelo Simples sem permissão de crédito" },
    { selectName: "csosn", value: "103", label: "103 — Isenção do ICMS para faixa de receita bruta" },
    { selectName: "csosn", value: "201", label: "201 — Tributada pelo Simples com crédito e cobrança do ICMS por ST" },
    { selectName: "csosn", value: "202", label: "202 — Tributada pelo Simples sem crédito e cobrança do ICMS por ST" },
    { selectName: "csosn", value: "203", label: "203 — Isenção para faixa de receita bruta e cobrança do ICMS por ST" },
    { selectName: "csosn", value: "300", label: "300 — Imune" },
    { selectName: "csosn", value: "400", label: "400 — Não tributada pelo Simples Nacional" },
    { selectName: "csosn", value: "500", label: "500 — ICMS cobrado anteriormente por ST ou por antecipação" },
    { selectName: "csosn", value: "900", label: "900 — Outros" },
]

const SIMPLES_REGIMES = ['simples_nacional', 'simples_excesso']

const EMPTY_RECIPIENT = { personType: "fisica", address: {} }
const EMPTY_ITEM_DRAFT = { unit: 'UN', origin: '0' }

// Ícone do botão "Emitir": o ícone de nota fiscal do tamanho normal, com uma setinha pra
// cima num badge no canto inferior direito — como se fosse um ícone só, reforçando que a
// ação envia/emite a nota (Button.js só suporta um ícone por variant — combinamos os dois
// aqui e sobrescrevemos o sizing padrão de .btn-icon svg via CSS escopado).
function EmitInvoiceIcon() {
    return (
        <span className="fi-emit-icon-group">
            <FaFileInvoiceDollar />
            <span className="fi-emit-icon-badge"><FaArrowUp /></span>
        </span>
    )
}

function FormInvoice({ handleSubmit, initialData, btnText, btCancelAction, title, formErrors }) {
    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()

    const [type, setType] = useState((initialData && initialData.type) || 'nfe')
    const [order] = useState((initialData && initialData.order) || null)
    const [recipient, setRecipient] = useState((initialData && initialData.recipient) || EMPTY_RECIPIENT)
    const [items, setItems] = useState((initialData && initialData.items) || [])
    const [itemDraft, setItemDraft] = useState(EMPTY_ITEM_DRAFT)
    const [modalAddItem, setModalAddItem] = useState(false)
    const [ncmSuggestQuery, setNcmSuggestQuery] = useState('')
    const [editingItemIndex, setEditingItemIndex] = useState(null)
    const [modalDeleteItem, setModalDeleteItem] = useState(false)
    const [deleteItemIndex, setDeleteItemIndex] = useState(null)

    const [products, setProducts] = useState([])
    const [regimeTributario, setRegimeTributario] = useState('')

    useEffect(() => {
        api.get('/product/getall', { headers: { Authorization: `Bearer ${JSON.parse(token)}` } }).then((response) => {
            setProducts((response.data.products || []).map((p) => ({ value: p._id, label: `#${p.code} — ${p.description}`, product: p })))
        })
        // Define se cada item pede CST (regime normal) ou CSOSN (Simples Nacional) — vem do
        // Perfil da Empresa, não é uma escolha por nota.
        api.get('/fiscal/config', { headers: { Authorization: `Bearer ${JSON.parse(token)}` } }).then((response) => {
            setRegimeTributario(response.data.fiscalConfig?.regimeTributario || '')
        }).catch(() => {})
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token])

    const isSimples = SIMPLES_REGIMES.includes(regimeTributario)

    function handleNcmPicked(n) {
        setItemDraft((prev) => ({ ...prev, ncm: n.code, ncmDescription: n.description }))
    }

    function handleCfopPicked(c) {
        setItemDraft((prev) => ({ ...prev, cfop: c.code, cfopDescription: c.description }))
    }

    function handleTypeChange(selectedOption) {
        setType(selectedOption.value)
    }

    function handleRecipientChange(e) {
        setRecipient({ ...recipient, [e.target.name]: e.target.value })
    }

    function handleRecipientAddressChange(e) {
        setRecipient({ ...recipient, address: { ...(recipient.address || {}), [e.target.name]: e.target.value } })
    }

    function handleRecipientAddressSelect(selectedOption) {
        // Trocar a UF invalida a cidade escolhida antes (era de outro estado).
        if (selectedOption.selectName === 'state') {
            setRecipient({ ...recipient, address: { ...(recipient.address || {}), state: selectedOption.value, city: '' } })
            return
        }
        setRecipient({ ...recipient, address: { ...(recipient.address || {}), [selectedOption.selectName]: selectedOption.value } })
    }

    function handleRecipientCepFound(address) {
        setRecipient((prev) => ({
            ...prev,
            address: {
                ...(prev.address || {}),
                street: address.street || prev.address?.street,
                district: address.district || prev.address?.district,
                city: address.city || prev.address?.city,
                state: address.state || prev.address?.state,
                cityCode: address.cityCode || prev.address?.cityCode,
            },
        }))
    }

    function handleRecipientRadio(name, value) {
        setRecipient({ ...recipient, [name]: value })
    }

    function handleIeIndicatorChange(selectedOption) {
        setRecipient({ ...recipient, ieIndicator: selectedOption.value })
    }

    function handleClientPicked(c) {
        setRecipient({
            client: c._id,
            name: c.name,
            personType: c.personType,
            CNPJ: c.CNPJ,
            CPF: c.CPF,
            IE: c.stateRegistration,
            ieIndicator: c.ieIndicator,
            address: {
                street: c.address,
                number: c.number,
                complement: c.complement,
                district: c.district,
                cep: c.cep,
                city: c.city,
                state: c.state,
                cityCode: c.cityCode,
            },
        })
    }

    function handleItemDraftChange(e) {
        // Editar o NCM/CFOP na mão descola do código que gerou a descrição — some o texto de apoio.
        if (e.target.name === "ncm") {
            setItemDraft({ ...itemDraft, ncm: e.target.value, ncmDescription: "" })
            return
        }
        if (e.target.name === "cfop") {
            setItemDraft({ ...itemDraft, cfop: e.target.value, cfopDescription: "" })
            return
        }
        setItemDraft({ ...itemDraft, [e.target.name]: e.target.value })
    }

    function handleOriginChange(selectedOption) {
        setItemDraft({ ...itemDraft, origin: selectedOption.value })
    }

    function handleCstCsosnChange(selectedOption) {
        setItemDraft({ ...itemDraft, [selectedOption.selectName]: selectedOption.value })
    }

    function handleUnitChange(selectedOption) {
        setItemDraft({ ...itemDraft, unit: selectedOption.value })
    }

    function handleProductSelect(option) {
        const p = option.product
        // Nem p.description (começa com o nome do fornecedor, uso interno) nem p.unit (unidade
        // de compra do tecido — metro/kg) servem pra nota: a peça já foi fabricada, é vendida
        // por unidade, com uma descrição reconstruída só com dados apropriados pro cliente.
        const description = [p.category?.label || p.category?.name, p.cloth?.label || p.cloth?.name, p.sex?.label]
            .filter(Boolean)
            .join(' — ') || p.description
        setItemDraft({
            ...itemDraft,
            description,
            unit: 'UN',
        })
        // O Produto não guarda NCM (depende do tecido/composição, escolhido só na nota) — a
        // categoria da peça vira a busca inicial do modal de NCM, pra agilizar sem autopreencher.
        setNcmSuggestQuery(p.category?.name || '')
    }

    function addItem() {
        if (!itemDraft.description) {
            setFlashMessage('A descrição do item é obrigatória', 'error')
            return
        }
        if (!itemDraft.ncm) {
            setFlashMessage('O NCM do item é obrigatório', 'error')
            return
        }
        if (!itemDraft.cfop) {
            setFlashMessage('O CFOP do item é obrigatório', 'error')
            return
        }
        if (isSimples) {
            if (!itemDraft.csosn) {
                setFlashMessage('O CSOSN do item é obrigatório (emitente no Simples Nacional)', 'error')
                return
            }
        } else if (!itemDraft.cst) {
            setFlashMessage('O CST do item é obrigatório', 'error')
            return
        }
        if (!itemDraft.origin) {
            setFlashMessage('A origem do item é obrigatória', 'error')
            return
        }
        if (!itemDraft.unit) {
            setFlashMessage('A unidade do item é obrigatória', 'error')
            return
        }
        if (!itemDraft.quantity) {
            setFlashMessage('A quantidade do item é obrigatória', 'error')
            return
        }
        if (!itemDraft.unitValue) {
            setFlashMessage('O valor unitário do item é obrigatório', 'error')
            return
        }
        const quantity = parseFloat(itemDraft.quantity) || 0
        const unitValue = parseFloat(itemDraft.unitValue) || 0
        const finalItem = { ...itemDraft, quantity, unitValue, totalValue: (quantity * unitValue).toFixed(2) }

        if (editingItemIndex !== null) {
            setItems(items.map((it, i) => (i === editingItemIndex ? finalItem : it)))
        } else {
            setItems([...items, finalItem])
        }
        setItemDraft(EMPTY_ITEM_DRAFT)
        setNcmSuggestQuery('')
        setEditingItemIndex(null)
        setModalAddItem(false)
    }

    function removeItem(idx) {
        setItems(items.filter((_, i) => i !== idx))
    }

    function askRemoveItem(idx) {
        setDeleteItemIndex(idx)
        setModalDeleteItem(true)
    }

    function confirmRemoveItem() {
        removeItem(deleteItemIndex)
        setDeleteItemIndex(null)
        setModalDeleteItem(false)
    }

    function openAddItemModal() {
        setItemDraft(EMPTY_ITEM_DRAFT)
        setNcmSuggestQuery('')
        setEditingItemIndex(null)
        setModalAddItem(true)
    }

    function openEditItemModal(idx) {
        setItemDraft({ ...items[idx] })
        setNcmSuggestQuery('')
        setEditingItemIndex(idx)
        setModalAddItem(true)
    }

    function submitItemDraft(e) {
        e.preventDefault()
        // O <form> do modal de item, embora renderizado via portal (Modal.js -> document.body),
        // continua sendo descendente do <form> principal na árvore do React — sem isso, o submit
        // do item borbulha (evento sintético segue a árvore React, não o DOM) e também aciona o
        // onSubmit do formulário da nota inteira, disparando a emissão sem querer.
        e.stopPropagation()
        addItem()
    }

    function closeAddItemModal() {
        setItemDraft(EMPTY_ITEM_DRAFT)
        setNcmSuggestQuery('')
        setEditingItemIndex(null)
        setModalAddItem(false)
    }

    function submit(e) {
        e.preventDefault()
        handleSubmit({ order: order ? order._id : null, type, recipient, items })
    }

    const itemsTotal = items.reduce((acc, it) => acc + (parseFloat(it.totalValue) || 0), 0)

    return (
        <FormLayout
            title={
                <>
                    {title}
                    {order && (
                        <span className="fi-linked-order-header">
                            <FaLink size={13} /> Pedido #{order.code}
                        </span>
                    )}
                </>
            }
            onSubmit={submit}
            actions={
                <>
                    <Button variant="save" type="submit" icon={EmitInvoiceIcon}>{btnText || 'Emitir'}</Button>
                    {btCancelAction && <Button variant="cancel" onClick={btCancelAction}>Cancelar</Button>}
                </>
            }
        >
            {formErrors && formErrors.length > 0 && (
                <div className="fi-errors">
                    <p className="fi-errors-title">Não foi possível emitir a nota:</p>
                    <ul className="fi-errors-list">
                        {formErrors.map((err, idx) => <li key={idx}>{err}</li>)}
                    </ul>
                </div>
            )}

            <FormSection label="Tipo de Documento">
                <div className="fl-row">
                    <div className="fl-col-mid form-group">
                        <Select
                            options={TYPE_OPTIONS}
                            styles={selectStyles}
                            onChange={handleTypeChange}
                            value={TYPE_OPTIONS.find((o) => o.value === type)}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                        />
                    </div>
                </div>
            </FormSection>

            <FormSection label="Destinatário">
                <div className="fl-row">
                    <div className="fl-col-wide form-group">
                        <label className="input-label">Nome / Razão Social</label>
                        <ClientSearchTrigger name="name" value={recipient.name} handleOnChange={handleRecipientChange} onSelect={handleClientPicked} />
                    </div>
                </div>
                <div className="fl-row">
                    <div className="fl-col-wide form-group">
                        <Radio
                            options={[{ value: 'fisica', label: "Pessoa física" }, { value: 'juridica', label: "Pessoa jurídica" }]}
                            name="personType"
                            value={recipient.personType}
                            defaultValue="fisica"
                            handleOnChange={handleRecipientRadio}
                        />
                    </div>
                </div>
                <div className="fl-row">
                    {recipient.personType === 'juridica' ? (
                        <div className="fl-col-narrow form-group">
                            <Input text="CNPJ" type="text" name="CNPJ" handleOnChange={handleRecipientChange} value={recipient.CNPJ || ''} />
                        </div>
                    ) : (
                        <div className="fl-col-narrow form-group">
                            <Input text="CPF" type="text" name="CPF" handleOnChange={handleRecipientChange} value={recipient.CPF || ''} />
                        </div>
                    )}
                    <div className="fl-col-narrow form-group">
                        <Input text="Inscrição Estadual" type="text" name="IE" placeholder="obrigatório se contribuinte" handleOnChange={handleRecipientChange} value={recipient.IE || ''} />
                    </div>
                    <div className="fl-col-mid form-group">
                        <label className="input-label">Indicador de IE:</label>
                        <Select
                            options={IE_INDICATOR_OPTIONS}
                            styles={selectStyles}
                            onChange={handleIeIndicatorChange}
                            value={IE_INDICATOR_OPTIONS.find((o) => o.value === recipient.ieIndicator) || ''}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                        />
                    </div>
                </div>
                <div className="fl-row">
                    <div className="fl-col-narrow form-group">
                        <label className="input-label">CEP</label>
                        <CepSearchTrigger name="cep" value={recipient.address && recipient.address.cep} handleOnChange={handleRecipientAddressChange} onFound={handleRecipientCepFound} />
                    </div>
                    <div className="fl-col-wide form-group">
                        <Input text="Endereço" type="text" name="street" handleOnChange={handleRecipientAddressChange} value={(recipient.address && recipient.address.street) || ''} />
                    </div>
                    <div className="fl-col-narrow form-group">
                        <Input text="Número" type="text" name="number" handleOnChange={handleRecipientAddressChange} value={(recipient.address && recipient.address.number) || ''} />
                    </div>
                    <div className="fl-col-narrow form-group">
                        <Input text="Complemento" type="text" name="complement" handleOnChange={handleRecipientAddressChange} value={(recipient.address && recipient.address.complement) || ''} />
                    </div>
                </div>
                <div className="fl-row">
                    <div className="fl-col-mid form-group">
                        <Input text="Bairro" type="text" name="district" handleOnChange={handleRecipientAddressChange} value={(recipient.address && recipient.address.district) || ''} />
                    </div>
                    <div className="fl-col-narrow form-group">
                        <label className="input-label">UF</label>
                        <UfSelect value={recipient.address && recipient.address.state} onChange={handleRecipientAddressSelect} />
                    </div>
                    <div className="fl-col-mid form-group">
                        <label className="input-label">Cidade</label>
                        <CitySelect uf={recipient.address && recipient.address.state} value={recipient.address && recipient.address.city} onChange={handleRecipientAddressSelect} />
                    </div>
                </div>
            </FormSection>

            <FormSection label="Itens">
                <button type="button" className="fi-select-btn" onClick={openAddItemModal}>
                    <FaPlus size={16} /><span>Adicionar Item</span>
                </button>

                {items.length > 0 && (
                    <div className="fi-items-table-wrap">
                        <table className="fi-items-table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Descrição</th>
                                    <th>NCM</th>
                                    <th>CFOP</th>
                                    <th>{isSimples ? 'CSOSN' : 'CST'}</th>
                                    <th>Unid.</th>
                                    <th>Qtd.</th>
                                    <th>Valor Unit.</th>
                                    <th>Valor Total</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {items.map((it, idx) => (
                                    <tr key={idx} className="fi-items-table-row" title="Clique para editar" onClick={() => openEditItemModal(idx)}>
                                        <td>{idx + 1}</td>
                                        <td className="fi-items-table-desc">{it.description}</td>
                                        <td title={it.ncmDescription || ''}>{it.ncm || <span className="fi-items-table-pending">pendente</span>}</td>
                                        <td title={it.cfopDescription || ''}>{it.cfop || <span className="fi-items-table-pending">pendente</span>}</td>
                                        <td>{(isSimples ? it.csosn : it.cst) || <span className="fi-items-table-pending">pendente</span>}</td>
                                        <td>{it.unit}</td>
                                        <td>{it.quantity}</td>
                                        <td>{it.unitValue ? `R$ ${it.unitValue}` : ''}</td>
                                        <td className="fi-items-table-total-cell">{it.totalValue ? `R$ ${it.totalValue}` : ''}</td>
                                        <td className="fi-items-table-actions">
                                            <FaPencilAlt className="shd-icon-row-edit" title="Editar" onClick={(e) => { e.stopPropagation(); openEditItemModal(idx) }} />
                                            <FaTrashAlt className="shd-icon-row-trash" title="Remover" onClick={(e) => { e.stopPropagation(); askRemoveItem(idx) }} />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colSpan={8} className="fi-items-table-footer-label">Total dos itens</td>
                                    <td className="fi-items-table-total-cell"><strong>R$ {itemsTotal.toFixed(2)}</strong></td>
                                    <td></td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                )}

                <Modal
                    modalStatus={modalAddItem}
                    changeStatus={setModalAddItem}
                    w={70}
                    content={
                        <FormLayout
                            title={editingItemIndex !== null ? "Editar Item" : "Adicionar Item"}
                            onSubmit={submitItemDraft}
                            actions={
                                <>
                                    <Button variant="finish" type="submit">{editingItemIndex !== null ? "Salvar" : "Adicionar"}</Button>
                                    <Button variant="cancel" type="button" onClick={closeAddItemModal}>Cancelar</Button>
                                </>
                            }
                        >
                            <div className="fl-row">
                                <div className="fl-col-wide form-group">
                                    <label className="input-label">Selecionar produto (opcional):</label>
                                    <Select
                                        options={products}
                                        styles={selectStyles}
                                        onChange={handleProductSelect}
                                        value=""
                                        placeholder="Autopreencher a partir de um produto..."
                                        menuPortalTarget={document.body}
                                        menuPosition="fixed"
                                    />
                                </div>
                            </div>
                            <div className="fl-row">
                                <div className="fl-col-wide form-group">
                                    <Input text="Descrição" type="text" name="description" handleOnChange={handleItemDraftChange} value={itemDraft.description || ''} />
                                </div>
                                <div className="fl-col-narrow form-group">
                                    <label className="input-label">NCM</label>
                                    <NcmSearchTrigger name="ncm" value={itemDraft.ncm} handleOnChange={handleItemDraftChange} onSelect={handleNcmPicked} suggestQuery={ncmSuggestQuery} />
                                    {itemDraft.ncmDescription && <span className="fl-section-hint">{itemDraft.ncmDescription}</span>}
                                </div>
                                <div className="fl-col-narrow form-group">
                                    <label className="input-label">CFOP</label>
                                    <CfopSearchTrigger name="cfop" value={itemDraft.cfop} handleOnChange={handleItemDraftChange} onSelect={handleCfopPicked} />
                                    {itemDraft.cfopDescription && <span className="fl-section-hint">{itemDraft.cfopDescription}</span>}
                                </div>
                            </div>
                            <div className="fl-row">
                                <div className="fl-col-narrow form-group">
                                    <Input text="CEST" type="text" name="cest" placeholder="opcional" handleOnChange={handleItemDraftChange} value={itemDraft.cest || ''} />
                                </div>
                                <div className="fl-col-narrow form-group">
                                    <label className="input-label">{isSimples ? 'CSOSN' : 'CST'}</label>
                                    <Select
                                        options={isSimples ? CSOSN_OPTIONS : CST_OPTIONS}
                                        styles={selectStyles}
                                        onChange={handleCstCsosnChange}
                                        value={(isSimples ? CSOSN_OPTIONS : CST_OPTIONS).find((o) => o.value === (isSimples ? itemDraft.csosn : itemDraft.cst)) || ''}
                                        menuPortalTarget={document.body}
                                        menuPosition="fixed"
                                    />
                                </div>
                                <div className="fl-col-narrow form-group">
                                    <label className="input-label">Origem</label>
                                    <Select
                                        options={ORIGIN_OPTIONS}
                                        styles={selectStyles}
                                        onChange={handleOriginChange}
                                        value={ORIGIN_OPTIONS.find((o) => o.value === itemDraft.origin) || ''}
                                        menuPortalTarget={document.body}
                                        menuPosition="fixed"
                                    />
                                </div>
                                <div className="fl-col-narrow form-group">
                                    <label className="input-label">Unidade</label>
                                    <Select
                                        options={UNIT_OPTIONS}
                                        styles={selectStyles}
                                        onChange={handleUnitChange}
                                        value={UNIT_OPTIONS.find((o) => o.value === itemDraft.unit) || ''}
                                        menuPortalTarget={document.body}
                                        menuPosition="fixed"
                                    />
                                </div>
                                <div className="fl-col-narrow form-group">
                                    <Input text="Quantidade" type="number" name="quantity" handleOnChange={handleItemDraftChange} value={itemDraft.quantity || ''} />
                                </div>
                                <div className="fl-col-narrow form-group">
                                    <Input text="Valor Unitário (R$)" type="number" name="unitValue" handleOnChange={handleItemDraftChange} value={itemDraft.unitValue || ''} />
                                </div>
                            </div>
                            <div className="fi-item-draft-total">
                                Valor total do item: <strong>R$ {((parseFloat(itemDraft.quantity) || 0) * (parseFloat(itemDraft.unitValue) || 0)).toFixed(2)}</strong>
                            </div>
                        </FormLayout>
                    }
                />

                <ConfirmDeleteModal
                    modalStatus={modalDeleteItem}
                    changeStatus={setModalDeleteItem}
                    onConfirm={confirmRemoveItem}
                    message="Deseja realmente excluir este item da nota?"
                    itemName={deleteItemIndex !== null ? items[deleteItemIndex]?.description : ''}
                />
            </FormSection>
        </FormLayout>
    )
}

export default FormInvoice
